import React, { useState } from 'react';
import { Container, Card, Row, Col, Badge } from 'react-bootstrap';
import { FaStar, FaUserCircle, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';

// Hardcoded demo data — Reviews API is upcoming
const DEMO_REVIEWS = [
  {
    id: 'demo-1',
    reviewer_name: 'Asha Mwajuma',
    rating: 5,
    comment: 'Huduma bora kabisa, walifanya kila kitu kwa wakati na kwa ustadi mkubwa! Ninapendekeza sana kwa watakaokusudia harusi yao.',
    created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
    event_type: 'Harusi'
  },
  {
    id: 'demo-2',
    reviewer_name: 'John Kapinga',
    rating: 4,
    comment: 'Nimeridhika na maandalizi, timu ilikuwa ya kirafiki na kali katika kazi yao. Ingekuwa vizuri iwapo bei ingekuwa nafuu kidogo.',
    created_at: new Date(Date.now() - 86400000 * 7).toISOString(),
    event_type: 'Sherehe ya Birthday'
  },
  {
    id: 'demo-3',
    reviewer_name: 'Fatuma Said',
    rating: 5,
    comment: 'Team ilikuwa ya kirafiki na kazi yao ni ya ubora wa hali ya juu. Picha zilizotoka zilikuwa za ajabu kabisa!',
    created_at: new Date(Date.now() - 86400000 * 14).toISOString(),
    event_type: 'Harusi'
  },
  {
    id: 'demo-4',
    reviewer_name: 'Baraka Mwamba',
    rating: 4,
    comment: 'Maandalizi yalikuwa mazuri, yalitimia vizuri. Nilikuwa na wasiwasi kabla lakini team ilinihakikishia kila hatua.',
    created_at: new Date(Date.now() - 86400000 * 21).toISOString(),
    event_type: 'Reception'
  },
  {
    id: 'demo-5',
    reviewer_name: 'Grace Kimaro',
    rating: 5,
    comment: 'Bora zaidi kuliko nilivyotegemea! Kila kitu kilikuwa kizuri, tangu mapambo hadi chakula. Asante sana!',
    created_at: new Date(Date.now() - 86400000 * 30).toISOString(),
    event_type: 'Harusi'
  },
  {
    id: 'demo-6',
    reviewer_name: 'Juma Hassan',
    rating: 3,
    comment: 'Huduma ilikuwa nzuri lakini kulikuwa na ucheleweshaji kidogo mwanzoni. Baadaye kila kitu kilikwenda vizuri.',
    created_at: new Date(Date.now() - 86400000 * 45).toISOString(),
    event_type: 'Arusi'
  }
];

const Reviews = () => {
  const [reviews] = useState(DEMO_REVIEWS);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        stars.push(<FaStar key={i} className="text-warning" style={{ fontSize: '1rem', marginRight: '1px' }} />);
      } else if (i === Math.ceil(rating) && rating % 1 >= 0.5) {
        stars.push(<FaStarHalfAlt key={i} className="text-warning" style={{ fontSize: '1rem', marginRight: '1px' }} />);
      } else {
        stars.push(<FaRegStar key={i} className="text-warning" style={{ fontSize: '1rem', marginRight: '1px', opacity: 0.4 }} />);
      }
    }
    return stars;
  };

  const getAverageRating = () => {
    if (reviews.length === 0) return 0;
    const total = reviews.reduce((acc, rev) => acc + (Number(rev.rating) || 0), 0);
    return (total / reviews.length).toFixed(1);
  };

  const getRatingCounts = () => {
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    reviews.forEach(rev => {
      const r = Math.round(Number(rev.rating));
      if (counts[r] !== undefined) counts[r]++;
    });
    return counts;
  };

  const avgRating = parseFloat(getAverageRating());
  const ratingCounts = getRatingCounts();

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString('sw-TZ', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return 'Hivi Karibuni';
    }
  };

  return (
    <Container className="mt-4 pb-5">
      {/* Header */}
      <div className="mb-4 d-flex justify-content-center align-items-center text-center w-100">
        <div>
          <h1 className="stylish-heading mb-1 text-center" style={{ color: '#4169e1' }}>Maoni ya Wateja</h1>
          <p className="text-muted mb-0 small text-center">
            Kipengele hiki kinakuja hivi karibuni
          </p>
        </div>
      </div>

      {/* Rating Summary Card */}
      <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '16px', overflow: 'hidden' }}>
        <Card.Body className="p-4" style={{ background: 'linear-gradient(135deg, #f8f9ff 0%, #eef2ff 100%)' }}>
          <Row className="align-items-center g-4">
            {/* Big Rating Score */}
            <Col xs="auto" className="text-center pe-4 border-end">
              <div className="fw-bold" style={{ fontSize: '4rem', lineHeight: 1, color: '#4169e1' }}>
                {avgRating}
              </div>
              <div className="mb-1">{renderStars(avgRating)}</div>
              <div className="text-muted small">{reviews.length} Maoni</div>
            </Col>

            {/* Rating Bars */}
            <Col>
              {[5, 4, 3, 2, 1].map(star => {
                const count = ratingCounts[star] || 0;
                const pct = reviews.length > 0 ? Math.round((count / reviews.length) * 100) : 0;
                return (
                  <div key={star} className="d-flex align-items-center gap-2 mb-1">
                    <div className="text-muted small fw-semibold" style={{ width: '14px' }}>{star}</div>
                    <FaStar className="text-warning" style={{ fontSize: '0.75rem' }} />
                    <div className="flex-grow-1 bg-white rounded-pill overflow-hidden" style={{ height: '8px' }}>
                      <div
                        className="rounded-pill"
                        style={{
                          width: `${pct}%`,
                          height: '100%',
                          background: star >= 4 ? '#4169e1' : star === 3 ? '#f59e0b' : '#ef4444',
                          transition: 'width 0.5s ease'
                        }}
                      />
                    </div>
                    <div className="text-muted small" style={{ width: '24px' }}>{count}</div>
                  </div>
                );
              })}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Reviews Grid */}
      <Row className="g-3">
        {reviews.map((review, idx) => (
          <Col md={6} key={review.id || idx}>
            <Card
              className="h-100 border-0 shadow-sm"
              style={{ borderRadius: '14px', transition: 'transform 0.2s, box-shadow 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(65,105,225,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; }}
            >
              <Card.Body className="p-4">
                {/* Reviewer Info */}
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="d-flex justify-content-center align-items-center rounded-circle fw-bold text-white"
                      style={{
                        width: '44px',
                        height: '44px',
                        fontSize: '1rem',
                        background: `hsl(${(idx * 47 + 220) % 360}, 60%, 55%)`
                      }}
                    >
                      {(review.reviewer_name || 'M').charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div className="fw-bold mb-0" style={{ fontSize: '0.9rem' }}>
                        {review.reviewer_name || 'Mteja'}
                      </div>
                      <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        {review.event_type || ''}
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <div>{renderStars(Number(review.rating) || 5)}</div>
                    <div className="text-muted mt-1" style={{ fontSize: '0.72rem' }}>
                      {formatDate(review.created_at)}
                    </div>
                  </div>
                </div>

                {/* Comment */}
                <p
                  className="text-dark fst-italic mb-0"
                  style={{
                    lineHeight: '1.65',
                    fontSize: '0.88rem',
                    borderLeft: '3px solid #4169e1',
                    paddingLeft: '12px',
                    color: '#444'
                  }}
                >
                  "{review.comment || 'Hakuna maelezo ya ziada yaliyotolewa.'}"
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Reviews;
